import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, inject, Injectable } from '@angular/core';
import { ApplicationInsightService } from '../services/application-insights.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly applicationInsightService = inject(ApplicationInsightService);

  public handleError(error: Error | HttpErrorResponse) {
    this.applicationInsightService.logError(error);
  }
}
